export default "__VITE_ASSET__3850a28c__"